
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/intelligence",
      function () {
        return require("private-next-pages/intelligence.tsx");
      }
    ]);
  